import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CenterLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H2, H3, H7 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import { BTOutlineButton } from '../../common/components/BTOutlineButton';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const IntroduceSection8 = () => {
  const { t } = useTranslation();
  const { horizontal: padding } = useResponsivePadding();
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{ background: '#009944', paddingLeft: padding, paddingRight: padding, paddingBottom: isMobile ? '64px' : `${pxToRem(182)}` }}>
      {isMobile && (
        <VerticalLayout>
          <BTBox height={34} />
          {isChina ? (
            <CenterLayout>
              <H7 style={{ color: '#FFFFFF', opacity: '0.7' }}>Recruit</H7>
            </CenterLayout>
          ) : (
            <H7 style={{ color: '#FFFFFF', opacity: '0.7' }}>Recruit</H7>
          )}
          <BTBox height={8} />

          {isChina ? (
            <VerticalLayout style={{ alignContent: 'center', alignItems: 'center' }}>
              <H2 style={{ color: '#FFFFFF', fontSize: '26px' }}>{t('비비테크와 함께')}</H2>
              <H2 style={{ color: '#FFFFFF', fontSize: '26px' }}>{t('미래를 만들어갈 인재를 기다립니다.')}</H2>
            </VerticalLayout>
          ) : (
            <>
              <HorizontalLayout style={{ alignContent: 'center', alignItems: 'center' }}>
                <H2 style={{ color: '#FFFFFF', fontSize: '26px' }}>{t('비비테크와 함께')}</H2>
                <div
                  style={{
                    flex: 1,
                    height: '4px',
                    backgroundColor: '#FFFFFF',
                    marginLeft: '16px',
                    opacity: 1,
                  }}
                />
              </HorizontalLayout>
              <H2 style={{ color: '#FFFFFF', fontSize: '26px' }}>{t('미래를 만들어갈 인재를 기다립니다.')}</H2>
            </>
          )}
          {(!isEng && !isChina) && (
            <>
              <BTBox height={28} />
              <BTOutlineButton borderWidth={3} height={60} onClick={() => navigate('/recruit')} width='100%' fontSize={20} centered={true} data-analytics-name="인재영입_채용공고">
                {t('채용공고')}
              </BTOutlineButton>
              <BTBox height={16} />
              <BTOutlineButton borderWidth={3} height={60} onClick={() => navigate('/recruit/people')} width='100%' fontSize={20} centered={true} data-analytics-name="인재영입_인재상">
                {t('인재상')}
              </BTOutlineButton>
            </>
          )}
        </VerticalLayout>
      )}
      {!isMobile && (
        <VerticalLayout>
          <BTBox height={pxToRem(125)} />
          {isChina ? (
            <CenterLayout>
              <H7 style={{ color: '#FFFFFF', opacity: '0.7' }}>Recruit</H7>
            </CenterLayout>
          ) : (
            <H7 style={{ color: '#FFFFFF', opacity: '0.7' }}>Recruit</H7>
          )}
          <BTBox height={pxToRem(50)} />
          <HorizontalLayout style={{ width: '100%' }}>
            {isChina ? (
              <VerticalLayout style={{ alignItems: 'center' }}>
                <H3 style={{ color: '#FFFFFF', whiteSpace: 'nowrap' }}>
                  {t('비비테크와 함께')}
                </H3>

                <H3 style={{ color: '#FFFFFF' }}>
                  {t('미래를 만들어갈 인재를 기다립니다.')}
                </H3>
                <BTBox height={pxToRem(60)} />
              </VerticalLayout>
            ) : (
              <VerticalLayout style={{ width: '100%' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                  }}
                >
                  <H3 style={{ color: '#FFFFFF', whiteSpace: 'nowrap' }}>
                    {t('비비테크와 함께')}
                  </H3>
                  <div
                    style={{
                      flex: 1,
                      height: '6px',
                      backgroundColor: '#FFFFFF',
                      marginLeft: '16px',
                      opacity: 1,
                    }}
                  />
                </div>

                <H3 style={{ color: '#FFFFFF' }}>
                  {t('미래를 만들어갈 인재를 기다립니다.')}
                </H3>
                <BTBox height={pxToRem(60)} />
              </VerticalLayout>
            )}
            {(!isEng && !isChina) && (
              <>
                <BTBox width={pxToRem(200)} />
                <VerticalLayout wrapContents={true} width={pxToRem(580)} >
                  <BTOutlineButton fontSize={pxToRem(28)} centered={true} onClick={() => navigate('/recruit')} width={pxToRem(380)} height={pxToRem(80)} data-analytics-name="인재영입_채용공고">
                    {t('채용공고')}
                  </BTOutlineButton>
                  <BTBox height={pxToRem(23)} />
                  <BTOutlineButton fontSize={pxToRem(28)} centered={true} onClick={() => navigate('/recruit/people')} width={pxToRem(380)} height={pxToRem(80)} data-analytics-name="인재영입_인재상">
                    {t('인재상')}
                  </BTOutlineButton>
                </VerticalLayout>
              </>
            )}

          </HorizontalLayout>
        </VerticalLayout>
      )}
    </VerticalLayout>
  );
};

export default IntroduceSection8;
